import React, { Component } from "react";
import {  Navbar, Container } from "react-bootstrap";
import navbarLogo from "../resources/image/navbar_logo.png";
import { wepod_console } from "../resources/string/strings"

class NavBar extends Component {
  state = { navExpanded: false };

  render() {
    return (
      <Navbar
      className="toolbar shadow-sm  "
      style={{
          paddingLeft: 20,
          background: "var(--colorPrimary)",
        }}
        dir="rtl"
        collapseOnSelect
        sticky="top"
        expand="lg"
        variant="dark"
        onToggle={this.setNavExpanded}
        expanded={this.state.navExpanded}
      >
        <Container className="p-0">


                <div
                  className="col-12 text-center"
                  style={{color: "white",  padding:8, fontSize: 17, textAlign: "center"}}
                >
                  {wepod_console}

                </div>
            

        </Container>
      </Navbar>
    );
  }

  setNavExpanded = (expanded) => {
    this.setState({ navExpanded: expanded });
  };

  closeNav = () => {
    this.setState({ navExpanded: false });
  };

}


export default NavBar;
